/** Locale-aware formatting bound to the active display language (doc/20261023-i18n-zh-cn.md §3.1). */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formattersFor, type Formatters } from '../../../shared/locale/format.mjs';
import { currentDisplayLanguage } from './index';

export { formattersFor, type Formatters };

/** Formatters for the active display language, outside React. */
export function format(): Formatters {
  return formattersFor(currentDisplayLanguage());
}

/** Formatters that follow the display language, re-rendering when it changes. */
export function useFormat(): Formatters {
  const { i18n } = useTranslation();
  return useMemo(() => formattersFor(i18n.language), [i18n.language]);
}
